<!--Full Table Component-->
@if (data_ready && !table_extract) {
  <table [dataSource]="dataSource" class="series-table" mat-table #detailsSort="matSort"
    >
    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column" sticky>
        @if (title_columns.includes(column)) {
          <th *matHeaderCellDef mat-sort-header
            [style.width]="format_dict[column]?.width + 'px'"
            class="freeze-pane" mat-header-cell>
            @if (column !== 'status') {
              {{format_dict[column]?.title}}
            }
            @if (column === 'status') {
              <i class="icon-status"></i>
            }
          </th>
          <td *matCellDef="let series;"
            mat-cell [ngStyle]="format_dict[column]?.style" style="alignment: left; text-align: left">
            @if (column === 'Status') {
              <span class="fa flag flag--status fa-warning"
                [ngClass]="{'warning-none': !series[column] || series[column]==1, 'warning' : element[column]==2, 'error': element[column]==3}">
              </span>
              <!--<i [ngClass]="{'status-warn': element[column] === 2, 'status-action': element[column] === 3}"></i>-->
            }
            @if (column === 'name') {
              <div class="row center" [style.width]="format_dict[column]?.width + 'px'"
                [style.justify-content]="format_dict[column]?.style['text-align']==='right' ? 'flex-end' : format_dict[column].style['text-align']==='center' ? 'center':'flex-start'">
                <series-edit-button [series_id]="series.id" class="edit-inline hide-xs hideonprint"></series-edit-button>
                <a (debounceClick)="openChartDialog(series.attributes.name)" [dblClickCopy]="series.attributes[column]"
                [textContent]="series.attributes[column]" style="cursor:pointer;"></a>
                @if (series.attributes.kpi_level === 'Level 1') {
                  <span
                  class="kpi">KPI {{series.attributes.kpi_level.replace('Level', '')}}</span>
                }
              </div>
            }
            @if (column === 'description') {
              <div
                class="row center">
                @if (!columns.includes('name')) {
                  <series-edit-button [series_id]="series.id"
                  class="edit-inline hide-xs hideonprint"></series-edit-button>
                }
                <a (debounceClick)="openChartDialog(series.attributes.name)" [dblClickCopy]="series.attributes.name"
                  [textContent]="series.attributes[column]"
                [style.width]="tableUtils.setDescriptorWidth(column, series, format_dict, columns)"></a>
                @if (!columns.includes('name') && series.attributes.kpi_level === 'Level 1') {
                  <span
                  class="kpi">KPI {{series.attributes.kpi_level.replace('Level', '')}}</span>
                }
              </div>
            }
          </td>
        }
        @if (!title_columns.includes(column)) {
          <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell style="text-align:center;white-space: nowrap;">
            {{column | removeUnderscore | upperfirst}}
          </th>
          <td *matCellDef="let series;" mat-cell style="padding:0 4px;text-align:left;vertical-align: middle;">
            {{series.attributes[column] | removeUnderscore | upperfirst}}
          </td>
        }
      </ng-container>
    }
    <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columns;" mat-row></tr>
  </table>
}

<!--Table extract that slots into parent-->
@if (data_ready && table_extract) {
  @for (column of columns; track column) {
    <ng-container [matColumnDef]="column">
      <th *matHeaderCellDef mat-header-cell style="text-align:center;white-space: nowrap;" [mat-sort-header]="column">
        {{(column_name_map[column] || column) | removeUnderscore | upperfirst}}
      </th>
      <!--Note that this series comes from the parent table, in this case a row of GSS data, hence the capital 'ID'-->
      <td *matCellDef="let series" style="padding:0 4px;text-align:left;vertical-align: middle;">
        {{series_details[series.ID].attributes[column] | removeUnderscore | upperfirst}}
      </td>
    </ng-container>
  }
}
